import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import type { GapReport } from '@pepper/utils/src/types/seo'

const handleShareReport = async ({
  reportId,
  documentId,
  companyId,
}: {
  reportId: string
  documentId: string
  companyId: string
}): Promise<{
  status: 'error' | 'ok'
  data: GapReport | null
  error?: string
}> => {
  try {
    const response = await axios.put(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-gap/${reportId}/share`,
      {
        redirect_url: `${window.location.origin}/content-refresh-report/${reportId}/${documentId}`,
      }
    )

    return {
      data: response.data?.data,
      status: 'ok',
    }
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error?.response.data.errors[0].message,
    }
  }
}

export const useShareGapReport = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      reportId,
      companyId,
      documentId,
    }: {
      reportId: string
      companyId: string
      documentId: string
    }) => handleShareReport({ reportId, companyId, documentId }),
    onSuccess: (res, { companyId, reportId }) => {
      queryClient.setQueryData(['content-report', companyId, reportId], {
        ...res.data,
      })
    },
  })
}
